export enum MCFAStatusCode {
    McfClaims = "McfClaims",
    ClsClaimsCoordinator = "ClsClaimsCoordinator",
    ClosedOrDeniedByMcfa = "ClosedOrDeniedByMcfa",
    ClsTrafficClaims = "ClsTrafficClaims",
    DeniedWhseOrCarrier = "DeniedWhseOrCarrier",
    HoldAreaCarrierClaims = "HoldAreaCarrierClaims",
    IndyToBeProcessed = "IndyToBeProcessed",
    McfClaimsCoordinator = "McfClaimsCoordinator",
    McfReturnsManagement = "McfReturnsManagement",
    NeverReturned = "NeverReturned",
    ClsOntario = "ClsOntario",
    PatsyHoldingQueue = "PatsyHoldingQueue",
    PartsBookError = "PartsBookError",
    NeedsQuickFixToFinish = "NeedsQuickFixToFinish",
    NeedItemsReturnedToIndy = "NeedItemsReturnedToIndy",
    IndyClsHoldingQueue = "IndyClsHoldingQueue",
    CarrierServiceFailure = "CarrierServiceFailure",
    TechnicalHouston = "TechnicalHouston",
    TechnicalDenied = "TechnicalDenied",
    NeedToDebitOrCredit = "NeedToDebitOrCredit",
    VendorIssue = "VendorIssue",
    CreditIssued = "CreditIssued",
    ClsYorkRecvInspection = "ClsYorkRecvInspection",
    ClaimNowClosed = "ClaimNowClosed",
    ReturnToDropshipVendor = "ReturnToDropshipVendor",
    FileWRapidpartsDenied = "FileWRapidpartsDenied",
    RaymondClaims = "RaymondClaims",
    DealerToReturnToRaymond = "DealerToReturnToRaymond",
    ChemtoolClaims = "ChemtoolClaims",
    SuperiorClaims = "SuperiorClaims",
    DropshipSupplier = "DropshipSupplier",
}
